module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#trending",
      toString: function () {
        return this.url;
      }
    }